import React from 'react';
// import AppCache from '../modules/AppCache';
import LazyLoad from './LazyLoad';

export default class Footer extends React.Component {



	isMobile() {	//sniff a mobile browser
		if (navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPod/i)
		) {
			return true;
		}
		else return false;
	};

	fixedFooter() {
		const query = new URLSearchParams(window.location.search);
		if(window.location.pathname == '/store/UpdateRecurringUserInfoMessage.do' 
				|| (window.location.pathname == '/store/NewViewOrder.do' && query.get('userExist') && query.get('userExist') == 1)){
			return true;
		}
	}

	render() {
		let writerNumber
		const query = new URLSearchParams(window.location.search);
		if (query.get('writer_type')) {
			writerNumber = query.get('writer_type');
		}

		return (
			<>
				<div data-elementor-type="footer" data-elementor-id="10020"
					className="elementor elementor-10020 elementor-location-footer" data-elementor-post-type="elementor_library">
					<section
						className={`${this.props.data === "Order-page" ? "elementor-section elementor-top-section elementor-element elementor-element-5f67a77 elementor-section-full_width elementor-section-content-middle footerclass elementor-hidden-mobile elementor-section-height-default elementor-section-height-default" :
							"elementor-section elementor-top-section elementor-element elementor-element-5f67a77 elementor-section-full_width elementor-section-content-middle elementor-hidden-mobile elementor-section-height-default elementor-section-height-default"

							}`}>
						<div className="elementor-container elementor-column-gap-default">
							<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-75433f38"
								data-id="75433f38" data-element_type="column">
								<div className="elementor-widget-wrap elementor-element-populated">
									<section
										className="elementor-section elementor-inner-section elementor-element elementor-element-7c9eb8bb elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
										data-id="7c9eb8bb" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1c8563d0"
												data-id="1c8563d0" data-element_type="column">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-30e61c40 elementor-widget elementor-widget-image"
														data-id="30e61c40" data-element_type="widget" id="mw-footer-logo"
														data-widget_type="image.default">
														<div className="elementor-widget-container"> <a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters' : 'https://masterwriter.com/creative_writers'}> <LazyLoad width="800"
															height="127">
															<img src="/store/images/2022-05-WM_logoWhole_wR2@2x-1024x163.png"
															className="attachment-large size-large wp-image-5285" alt=""
															loading="lazy"
															srcSet="/store/images/2022-05-WM_logoWhole_wR2@2x-1024x163.png 1024w, /store/images/2022-05-WM_logoWhole_wR2@2x-300x48.png 300w, /store/images/2022-05-WM_logoWhole_wR2@2x-768x122.png 768w, /store/images/2022-05-WM_logoWhole_wR2@2x.png 1462w"
															sizes="(max-width: 800px) 100vw, 800px" /></LazyLoad> </a> </div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b245fd4"
												data-id="b245fd4" data-element_type="column">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-25c9f202 elementor-widget elementor-widget-text-editor"
														data-id="25c9f202" data-element_type="widget"
														data-widget_type="text-editor.default">
														<div className="elementor-widget-container"> © Copyright 2003 &#8211; {new Date().getFullYear()} |
															MasterWriter Inc. | All Rights Reserved</div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-248f7b02"
												data-id="248f7b02" data-element_type="column" id="social-bar-container"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-2230b086 elementor-widget elementor-widget-html"
														data-id="2230b086" data-element_type="widget"
														data-widget_type="html.default">
														<div className="elementor-widget-container">
															<div id="SocialBar">
																<div className="SB-icon"><a
																	href="https://www.facebook.com/MasterWriter/"><LazyLoad width="100%"><img
																		src="./images/2022-03-socialMedia_60x60_Facebook.png"
																		alt="Facebook" /></LazyLoad></a></div>
																<div className="SB-icon"><a
																	href="https://twitter.com/masterwritersb"><LazyLoad width="100%"><img
																		src="./images/socialMedia_60x60_X.png"
																		alt="Twitter" /></LazyLoad></a></div>
																<div className="SB-icon"><a
																	href="https://www.youtube.com/user/MasterwriterSoftware"><LazyLoad width="100%"><img
																		src="./images/2022-03-socialMedia_60x60_YouTube.png"
																		alt="YouTube" /></LazyLoad></a></div>
																<div className="SB-icon"><a
																	href="https://www.instagram.com/masterwriterapp"><LazyLoad width="100%"><img
																		src="./images/2022-03-socialMedia_60x60_Twitter.png"
																		alt="Instagram"/></LazyLoad></a></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</section>
					<section
						className={`elementor-section elementor-top-section elementor-element elementor-element-2b9c0c31 elementor-section-full_width elementor-section-content-middle elementor-hidden-desktop elementor-hidden-tablet elementor-section-height-default elementor-section-height-default ${this.fixedFooter()? 'footerclass' : ''}`}
						data-id="2b9c0c31" data-element_type="section"
						data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
						<div className="elementor-container elementor-column-gap-default">
							<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-39d1d2ac"
								data-id="39d1d2ac" data-element_type="column">
								<div className="elementor-widget-wrap elementor-element-populated">
									<section
										className="elementor-section elementor-inner-section elementor-element elementor-element-508da73d elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
										data-id="508da73d" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-75d95a77"
												data-id="75d95a77" data-element_type="column">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-3c1c3624 elementor-widget elementor-widget-image"
														data-id="3c1c3624" data-element_type="widget"
														data-widget_type="image.default">
														<div className="elementor-widget-container"> <a href={writerNumber == "2" ? 'https://masterwriter.com/songwriters' : 'https://masterwriter.com/creative_writers'}> <LazyLoad width="800"
															height="127">
															<img src="./images/2022-05-WM_logoWhole_wR2@2x-1024x163.png"
															className="attachment-large size-large wp-image-5285" alt=""
															loading="lazy"
															srcSet="./images/2022-05-WM_logoWhole_wR2@2x-1024x163.png 1024w, ./images/2022-05-WM_logoWhole_wR2@2x-300x48.png 300w, ./images/2022-05-WM_logoWhole_wR2@2x-768x122.png 768w, ./images/2022-05-WM_logoWhole_wR2@2x.png 1462w"
															sizes="(max-width: 800px) 100vw, 800px" /></LazyLoad> </a> </div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-8c5d06"
												data-id="8c5d06" data-element_type="column">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-a9980fd elementor-widget elementor-widget-text-editor"
														data-id="a9980fd" data-element_type="widget"
														data-widget_type="text-editor.default">
														<div className="elementor-widget-container"> © Copyright 2003 &#8211; {new Date().getFullYear()} |
															MasterWriter Inc. | All Rights Reserved </div>
													</div>
												</div>
											</div>
											<div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7c7d8717"
												data-id="7c7d8717" data-element_type="column"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
												<div className="elementor-widget-wrap elementor-element-populated">
													<div className="elementor-element elementor-element-12ffb2d0 elementor-widget elementor-widget-html"
														data-id="12ffb2d0" data-element_type="widget"
														data-widget_type="html.default">
														<div className="elementor-widget-container">
															<div id="SocialBar">
																<div className="SB-icon"><a
																	href="https://www.facebook.com/MasterWriter/"><img
																		src="./images/2022-03-socialMedia_60x60_Facebook.png"
																		alt="Facebook" width="100%" /></a></div>
																<div className="SB-icon"><a
																	href="https://twitter.com/masterwritersb"><img
																		src="./images/socialMedia_60x60_X.png"
																		alt="Twitter" width="100%" /></a></div>
																<div className="SB-icon"><a
																	href="https://www.youtube.com/user/MasterwriterSoftware"><img
																		src="./images/2022-03-socialMedia_60x60_YouTube.png"
																		alt="YouTube" width="100%" /></a></div>
																<div className="SB-icon"><a
																	href="https://www.instagram.com/masterwriterapp"><img
																		src="./images/2022-03-socialMedia_60x60_Twitter.png"
																		alt="Instagram" width="100%" /></a></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</section>

					<div className="dialog-widget dialog-lightbox-widget dialog-type-buttons dialog-type-lightbox elementor-popup-modal"
						id="elementor-popup-modal-19108" aria-modal="true" role="document" tabIndex="0" style={{ display: this.isMobile() ? 'none' : 'none' }}>
						<div className="dialog-widget-content dialog-lightbox-widget-content animated" style={{ width: '100%' }}>
							<div className="dialog-header dialog-lightbox-header"></div>
							<div data-elementor-type="popup" data-elementor-id="19108"
								className="elementor elementor-19108 elementor-location-popup"
								data-elementor-settings="{&quot;entrance_animation&quot;:&quot;fadeInDown&quot;,&quot;exit_animation&quot;:&quot;fadeInDown&quot;,&quot;entrance_animation_duration&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0.6,&quot;sizes&quot;:[]},&quot;a11y_navigation&quot;:&quot;yes&quot;,&quot;timing&quot;:[]}"
								data-elementor-post-type="elementor_library" style={{ display: 'block' }}>
								<div className="elementor-element elementor-element-92381d3 e-flex e-con-boxed e-con" data-id="92381d3"
									data-element_type="container"
									data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
									<div className="e-con-inner">
										<div className="elementor-element elementor-element-a7dc136 elementor-widget elementor-widget-bdt-accordion"
											data-id="a7dc136" data-element_type="widget" data-widget_type="bdt-accordion.default">
											<div className="elementor-widget-container">
												<div className="bdt-ep-accordion-container">
													<div id="bdt-ep-accordion-a7dc136" className="bdt-ep-accordion bdt-accordion"
														data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:false,&quot;transition&quot;:&quot;ease-in-out&quot;}"
														data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-a7dc136&quot;,&quot;activeHash&quot;:&quot;no&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
														<div className="bdt-ep-accordion-item">
															<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle bdt-flex-between"
																id="bdt-ep-accordion-testimonials" data-accordion-index="0"
																data-title="testimonials" role="heading"> <span
																	className="bdt-ep-accordion-icon bdt-flex-align-right" aria-hidden="true"> <span
																		className="bdt-ep-accordion-icon-closed">

																		<svg viewBox="0 0 448 512">
																			<path
																				d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
																				fill="white" stroke="white"
																			/>
																		</svg></span> <span className="bdt-ep-accordion-icon-opened">
																		<svg viewBox="0 0 448 512">
																			<path
																				d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
																				fill="white" stroke="white"
																			/>
																		</svg>
																	</span> </span> <span
																		className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Testimonials </span>
															</div>
															<div className="bdt-ep-accordion-content bdt-accordion-content">
																<div className="mobile-submenus"> <a
																	href="/songwriters/testimonials/">Testimonials</a><br className="" /><a
																		href="/songwriters/notable_users/">Notable Users</a> </div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div data-ep-wrapper-link="{&quot;url&quot;:&quot;\/songwriting\/blog\/&quot;,&quot;is_external&quot;:&quot;&quot;,&quot;nofollow&quot;:&quot;&quot;,&quot;custom_attributes&quot;:&quot;&quot;}"
											style={{ cursor: 'pointer' }}
											className="bdt-element-link elementor-element elementor-element-3fd967d elementor-widget elementor-widget-bdt-accordion"
											data-id="3fd967d" data-element_type="widget" data-widget_type="bdt-accordion.default">
											<div className="elementor-widget-container">
												<div className="bdt-ep-accordion-container">
													<div id="bdt-ep-accordion-3fd967d" className="bdt-ep-accordion bdt-accordion"
														data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:true,&quot;transition&quot;:&quot;ease-in-out&quot;}"
														data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-3fd967d&quot;,&quot;activeHash&quot;:&quot;&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
														<div className="bdt-ep-accordion-item">
															<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle"
																id="bdt-ep-accordion-blog" data-accordion-index="0" data-title="blog"
																role="heading"> <span className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Blog
																</span> </div>
															<div className="bdt-ep-accordion-content bdt-accordion-content"> </div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-4ae0afc elementor-widget elementor-widget-bdt-accordion"
											data-id="4ae0afc" data-element_type="widget" data-widget_type="bdt-accordion.default">
											<div className="elementor-widget-container">
												<div className="bdt-ep-accordion-container">
													<div id="bdt-ep-accordion-4ae0afc" className="bdt-ep-accordion bdt-accordion"
														data-bdt-accordion="{&quot;collapsible&quot;:true,&quot;multiple&quot;:false,&quot;transition&quot;:&quot;ease-in-out&quot;}"
														data-settings="{&quot;id&quot;:&quot;bdt-ep-accordion-4ae0afc&quot;,&quot;activeHash&quot;:&quot;no&quot;,&quot;activeScrollspy&quot;:null,&quot;hashTopOffset&quot;:false,&quot;hashScrollspyTime&quot;:false}">
														<div className="bdt-ep-accordion-item">
															<div className="bdt-ep-accordion-title bdt-accordion-title bdt-flex bdt-flex-middle bdt-flex-between"
																id="bdt-ep-accordion-support" data-accordion-index="0" data-title="support"
																role="heading"> <span className="bdt-ep-accordion-icon bdt-flex-align-right"
																	aria-hidden="true"> <span className="bdt-ep-accordion-icon-closed"> <svg viewBox="0 0 448 512">
																		<path
																			d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
																			fill="white" stroke="white"
																		/>
																	</svg> </span> <span className="bdt-ep-accordion-icon-opened"> <svg viewBox="0 0 448 512">
																		<path
																			d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
																			fill="white" stroke="white"
																		/>
																	</svg></span> </span> <span
																		className="bdt-ep-title-text bdt-flex bdt-flex-middle"> Support </span> </div>
															<div className="bdt-ep-accordion-content bdt-accordion-content">
																<div className="mobile-submenus"> <a href="/songwriters/faqs/">FAQs</a> <br
																	className="" /> <a href="/songwriters/contact/">Contact</a> </div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="dialog-buttons-wrapper dialog-lightbox-buttons-wrapper" ></div><a role="button" tabIndex="0"
								aria-label="Close" href="#" className="dialog-close-button dialog-lightbox-close-button"><svg viewBox="0 0 448 512">


									<path d="m437.5,386.6l-130.6,-130.6l130.6,-130.6c14.1,-14.1 14.1,-36.8 0,-50.9c-14.1,-14.1 -36.8,-14.1 -50.9,0l-130.6,130.6l-130.6,-130.6c-14.1,-14.1 -36.8,-14.1 -50.9,0c-14.1,14.1 -14.1,36.8 0,50.9l130.6,130.6l-130.6,130.6c-14.1,14.1 -14.1,36.8 0,50.9c14.1,14.1 36.8,14.1 50.9,0l130.6,-130.6l130.6,130.6c14.1,14.1 36.8,14.1 50.9,0c14,-14.1 14,-36.9 0,-50.9z"
										fill="white" stroke="white"
									/>
								</svg></a>
						</div>
					</div>

				</div>



			</>
		)
	}

}
